import './Profile.css';
import logo from '../../../assets/images/my_picture.jpg';

function Profile() {
  return (
    <div className="profile-box">
      <img src={ logo } className="profile-image" alt="logo" />
      <div className="profile-text">  
        <h2 className="white-text">Johann Lee</h2>
        <h3 className="white-text">Software Engineer</h3>
        <p>
          Passionate software innovator, driven by challenges, eager to shape the future of engineering through collaboration.
        </p>
      </div>
    </div>
  )
}

export default Profile;